import React from 'react';

const RemoveUserNotification = ({status}) => {
    switch (status) {
        case "success":
            return (
                <p className="text-center text-success mt-4 pt-3"
                   data-lwt-id="remove-user-notification-success"
                >
                    User has been removed
                </p>
            );
        case "error":
            return (
                <p className="text-center text-danger mt-4 pt-3"
                   data-lwt-id="remove-user-notification-success"
                >
                    This user could not be removed. <br/>
                    Please contact your system administrator if the problem persists.
                </p>
            );
        default:
            return null
    }
};

export default RemoveUserNotification;